import React from "react";
import {
  Row,
  Modal,
  ModalBody,
  Button,
  Input,
  UncontrolledTooltip,
} from "reactstrap";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import {
  switchBtn,
  switchDelete,
  switchEnterEditMode,
  switchCancelEditMode,
  switchPreEdit,
  switchConfirmEdit,
} from "../redux/actions/switches.action";
import {
  editDeviceName,
  closeModal,
} from "../redux/actions/modal.devices.action";

import WizardSwitch from "./components/WizardSwitch";
import SwitchEdit from "./components/SwitchEdit";
import Switch from "./components/Switch";

const deviceName = /^[\p{L} \-\d]{0,24}$/u;
class Switches extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
    };
  }
  handleChangeName = (event) => {
    if (deviceName.test(event.target.value))
      this.setState({ name: event.target.value });
  };
  confirmDeviceName = () => {
    if (!deviceName.test(this.state.name) || !this.state.name.length) {
      return false;
      // send notif
    }
    this.props.editDeviceName(this.state.name);

    this.setState({
      name: "",
    });
  };

  render() {
    /*this.props.switches.sort(function(a, b) {
      return a.parent - b.parent;
    });*/
    return (
      <>
        <div className="content">
          <Modal
            className="modalNewDevice"
            isOpen={
              this.props.modal &&
              this.props.modal.display &&
              this.props.modal.type === "switch"
            }
            animation={false}
            fade={false}
          >
            <div className="modal-header justify-content-center">
              <button
                aria-hidden={true}
                className="close"
                data-dismiss="modal"
                type="button"
              >
                <i
                  className="tim-icons icon-simple-remove"
                  onClick={() => this.props.closeModal()}
                />
              </button>
              <h6 className="title title-up">
                {this.props.t(`modal.${this.props.modal.title}`)}
              </h6>
            </div>
            <ModalBody className="text-center">
              <p>{this.props.t(`modal.${this.props.modal.description}`)}</p>
              <Input
                style={{ color: "#1e1e2f" }}
                placeholder={this.props.t("common:name")}
                value={this.state.name}
                onChange={this.handleChangeName}
                type="text"
              />
            </ModalBody>
            <div className="modal-footer">
              <Button
                disabled={this.state.name.length < 1}
                color="default"
                type="button"
                onClick={() => this.confirmDeviceName()}
              >
                {this.props.t("common:confirm")}
              </Button>
            </div>
          </Modal>
          {this.props.switches && this.props.switches.length ? (
            <>
              <div className="devicesLimit">
                <span id="devicesLimit">{`${this.props.switches.length}/${
                  this.props.vip.plan < 2 ? "1" : "∞"
                }`}</span>
              </div>
              <UncontrolledTooltip
                delay={2}
                placement="right"
                target="devicesLimit"
              >
                {this.props.t("devicesLimits")}
              </UncontrolledTooltip>
              <Row className="switches">
                {this.props.switches.map((s) => {
                  return !s.isEdited ? (
                    <Switch
                      key={s.id}
                      id={s.id}
                      name={s.name}
                      commandPrefix={this.props.ingame.prefix}
                      command={s.command}
                      autoOn={s.autoOn}
                      isSAM={s.isSAM}
                      isAutoNight={s.isAutoNight}
                      isReverted={s.isReverted}
                      isAutoDay={s.isAutoDay}
                      isCyclic={s.isCyclic}
                      autoOff={s.autoOff}
                      state={s.state}
                      switchEnterEditMode={this.props.switchEnterEditMode}
                      switchBtn={this.props.switchBtn}
                      switchDelete={this.props.switchDelete}
                      parent={s.parent}
                      switches={this.props.switches}
                    />
                  ) : (
                    <SwitchEdit
                      key={`edit-${s.id}`}
                      id={s.id}
                      edit={s.edit}
                      switchCancelEditMode={this.props.switchCancelEditMode}
                      switchPreEdit={this.props.switchPreEdit}
                      switchConfirmEdit={this.props.switchConfirmEdit}
                      userPlan={this.props.vip.plan}
                      t={this.props.t}
                      switches={this.props.switches}
                    />
                  );
                })}
              </Row>
            </>
          ) : (
            <WizardSwitch />
          )}
        </div>
      </>
    );
  }
}

//export default Switches;

const mapStateToProps = (state) => {
  const { switches, modal } = state.devices;
  const { ingame } = state.settings;
  const { vip } = state.infos;
  return { switches, modal, vip, ingame };
};

const mapDispatchToProps = {
  switchBtn,
  switchDelete,
  switchEnterEditMode,
  switchCancelEditMode,
  switchPreEdit,
  switchConfirmEdit,
  editDeviceName,
  closeModal,
};

//export default Setup;
export default withTranslation(["devices", "common"])(
  connect(mapStateToProps, mapDispatchToProps)(Switches)
);
